import React from 'react';

import { SvgIcon } from '@material-ui/core';

import { send } from '../../../assets/icons';
import { AsaphIconButton } from '../Button';

export interface SendMessageButtonProps {
	disabled?: boolean;
	onClick: () => void;
}

export const SendMessageButton = ({
	disabled,
	onClick,
}: SendMessageButtonProps) => {
	const ariaLabel = 'send-message';
	return (
		<AsaphIconButton
			disabled={disabled}
			aria-label={ariaLabel}
			icon={<SvgIcon component={send} fontSize="small" />}
			color="blue"
			size="medium"
			onClick={onClick}
			type="submit"
		/>
	);
};
